<template>
    <v-card class="mx-auto elevation-0" max-width="1000">
        <template v-if="items.length > 0">
            <v-list dense class="pa-0">
                <v-list-item-group v-for="(item, i) in items" :key="i" v-model="model" multiple>
                    <v-list-item :value="item" :disabled="isDisabled || !isEditable">
                        <template v-slot:default="{ active }">
                            <v-list-item-action>
                                <checkbox
                                    :input-value="active"
                                    :true-value="item"
                                    :disabled="isDisabled || !isEditable"
                                    class="mt-0 mb-4"
                                />
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title :class="`${$options.name}__ListBodyText`" v-text="item.text" />
                            </v-list-item-content>
                        </template>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </template>
        <template v-else>
            <v-card-text>
                <card-empty-alert :message="$t('Execution_timing_list_not_found')" />
            </v-card-text>
        </template>
    </v-card>
</template>

<script lang="ts">
import { Vue, Component, Emit, Prop, Watch } from 'vue-property-decorator';
import { CardEmptyAlert, Checkbox } from '../atoms';

@Component({
    name: 'CheckboxList',
    components: {
        CardEmptyAlert,
        Checkbox,
    },
})
export default class CheckboxList extends Vue {
    @Prop({ type: Array, default: '' }) value: Array<string> | Array<number>;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: () => [] }) items: Array<any>;
    @Prop({ default: true }) readonly editable: boolean;

    @Emit()
    public input(value: Array<string> | Array<number>) {}

    get model(): Array<string> | Array<number> {
        return this.value;
    }
    set model(value: Array<string> | Array<number>) {
        this.input(value);
    }

    get isDisabled(): boolean {
        return this.disabled;
    }
    get isEditable(): boolean {
        return this.editable;
    }
    get itemsData(): Array<any> {
        return this.items;
    }
}
</script>
